// extracted by mini-css-extract-plugin
export var locationCard = "_ht-0";